import React, { useState } from 'react';
import { Check, ChevronDown, ChevronUp, Lock } from 'lucide-react';
import './Pricing.css';

import { auth } from './Auth'

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const Pricing = () => {
  const [expandedFreeFAQ, setExpandedFreeFAQ] = useState(null);
  const [expandedProFAQ, setExpandedProFAQ] = useState(null);

  const [subscriptionActive, setSubscriptionActive] = useState(false);
  
  const toggleFreeFAQ = (index) => {
    setExpandedFreeFAQ(expandedFreeFAQ === index ? null : index);
  };
  
  const toggleProFAQ = (index) => {
    setExpandedProFAQ(expandedProFAQ === index ? null : index);
  };
  
  // Free plan features
  const freeFeatures = [
    { feature: "Basic astrological insights", included: true },
    { feature: "Limited journal entries", included: true },
    { feature: "Daily cosmic vibes", included: true },
    { feature: "Basic being profile", included: true },
    { feature: "Community access", included: false },
    { feature: "Personalized recommendations", included: false },
    { feature: "Advanced astrological reports", included: false },
    { feature: "AI-powered insights", included: false },
    { feature: "Unlimited journal storage", included: false },
  ];
  
  // Pro plan features
  const proFeatures = [
    { feature: "Complete daily personalized insights and coaching", included: true },
    { feature: "Unlimited personalized prompts and advanced journaling analysis", included: true },
    { feature: "Fully customizable and interactive astrology 'calling' profile with AI guidance", included: true },
  ];
  
  // FAQ items
  const freeFAQs = [
    {
      question: "What's included in the free plan?",
      answer: "The free plan includes basic astrological insights, limited journal entries, daily cosmic vibes overview, and a basic being profile to get you started on your cosmic journey."
    },
    {
      question: "Are there any limitations?",
      answer: "Yes, the free plan limits the number of journal entries, provides only basic astrological insights, and doesn't include personalized recommendations or advanced features."
    },
    {
      question: "Can I upgrade later?",
      answer: "Absolutely! You can upgrade to the Pro plan at any time, and your existing data will seamlessly transfer to your upgraded account."
    }
  ];
  
  const proFAQs = [
    {
      question: "How does billing work?",
      answer: "We offer both monthly and annual billing options. Choose annual billing to receive a 20% discount. All payments are securely processed through PayPal or credit card."
    },
    {
      question: "Can I cancel my subscription?",
      answer: "Yes, you can cancel your subscription at any time. Your Pro benefits will continue until the end of your current billing period."
    },
    {
      question: "What makes Pro worth it?",
      answer: "Pro unlocks the full potential of Orb with personalized insights, unlimited journaling, detailed astrological reports, and AI-powered analysis customized to your unique cosmic blueprint."
    }
  ];

  const initialOptions = {
    clientId: "AfbLNF0ebY4GdMp_BOWWN2rUzk_hxcHHrq9p9am2Dv1QOdl4mPu2jOQVl51WH_l8OJg-tbR1wMPYwJx7",
    currency: "USD",
    intent: "subscription",
    vault: true,
  };

  const createMonthlySubscription = (data, actions) => {
    return actions.subscription.create({
      plan_id: 'P-8LT285691H250672WM76U6MQ'
    });
  };

  const createYearlySubscription = (data, actions) => {
    return actions.subscription.create({
      plan_id: 'P-7KY64379PG591952KM76U6MY'
    });
  };

  const onApprove = (data, actions) => {
    // Send subscription data to your backend
    return fetch('http://127.0.0.1:5001/orb-ai-project/us-central1/api/payment/capture', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.currentUser.getIdToken()}`
      },
      body: JSON.stringify({
        subscriptionID: data.subscriptionID,
      })
    })
    .then(response => response.json())
    .then(subscriptionData => {
      // Update UI to reflect active subscription
      setSubscriptionActive(true);
      return subscriptionData;
    });
  };

  return (
    <div className="pricing-container">
      <div className="pricing-header">
        <h1 className="pricing-title">Find Your Orbit</h1>
        <p className="pricing-subtitle">Choose the plan that best aligns with your cosmic journey</p>
      </div>
      
      <PayPalScriptProvider options={initialOptions}>
      <div className="pricing-plans">
        <div className="pricing-plan">
          <div className="plan-header">
            <h2 className="plan-name">Monthly</h2>
            <p className="plan-price">
              ${'33'}
              <span className="price-period">
                /{'month'}
              </span>
            </p>
            <br/>
            {/* <button className="plan-button pro-button">
              Upgrade
            </button> */}
            <PayPalButtons
              createSubscription={createMonthlySubscription}
              onApprove={onApprove}
              style={{ layout: "vertical" }}
            />
          </div>
        </div>

        <div className="pricing-plan pro-plan">
          <div className="plan-header">
            <h2 className="plan-name">Yearly</h2>
            <p className="plan-price">
              ${'300'}
              <span className="price-period">
                /{'year'}
              </span>
            </p>
              <p className="plan-savings">$96 savings annually</p>
            {/* <button className="plan-button pro-button">
              Upgrade
            </button> */}
            <PayPalButtons
              createSubscription={createYearlySubscription}
              onApprove={onApprove}
              style={{ layout: "vertical" }}
            />
          </div>
        </div>
      </div>
      </PayPalScriptProvider>

      <div className="plan-features">
            <h3 className="features-title">What's Included</h3>
            <ul className="features-list">
              {proFeatures.map((item, index) => (
                <li key={index} className="included">
                  <Check size={16} className="check-icon" />
                  <span>{item.feature}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="plan-faq">
            <h3 className="faq-title">Common Questions</h3>
            <div className="faq-list">
              {proFAQs.map((faq, index) => (
                <div 
                  key={index} 
                  className={`faq-item ${expandedProFAQ === index ? 'expanded' : ''}`}
                >
                  <div 
                    className="faq-question"
                    onClick={() => toggleProFAQ(index)}
                  >
                    <span>{faq.question}</span>
                    {expandedProFAQ === index ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    )}
                  </div>
                  {expandedProFAQ === index && (
                    <div className="faq-answer">{faq.answer}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
    </div>
  );
};

export default Pricing;